/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type { MetaForce, MetaForceInterface } from "../MetaForce";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "a",
        type: "uint256",
      },
    ],
    name: "FixedPointMathExp2ArgumentTooBig",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "a",
        type: "uint256",
      },
    ],
    name: "FixedPointMathLog2ArgumentTooBig",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "prod1",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "denominator",
        type: "uint256",
      },
    ],
    name: "FixedPointMathMulDivOverflow",
    type: "error",
  },
  {
    inputs: [],
    name: "GovernedCantGoverItself",
    type: "error",
  },
  {
    inputs: [],
    name: "GovernedGovernorZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "GovernedOnlyGovernorAllowedToCall",
    type: "error",
  },
  {
    inputs: [],
    name: "GovernedOnlyPendingGovernorAllowedToCall",
    type: "error",
  },
  {
    inputs: [],
    name: "MFCActivationAmountIs0",
    type: "error",
  },
  {
    inputs: [],
    name: "MFCAmountsIsNotChange",
    type: "error",
  },
  {
    inputs: [],
    name: "MFCAmountsLengthNotEqualToTierLevelCount",
    type: "error",
  },
  {
    inputs: [],
    name: "MFCEarlyStageForActivatePack",
    type: "error",
  },
  {
    inputs: [],
    name: "MFCEarlyStageForRenewalPackInHMFS",
    type: "error",
  },
  {
    inputs: [],
    name: "MFCLevelMoreMaxPackLevel",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    name: "MFCNeedActivatePack",
    type: "error",
  },
  {
    inputs: [],
    name: "MFCNotEnoughHMFSNeedLevel",
    type: "error",
  },
  {
    inputs: [],
    name: "MFCNotFirstActivationPack",
    type: "error",
  },
  {
    inputs: [],
    name: "MFCPackLevelIs0",
    type: "error",
  },
  {
    inputs: [],
    name: "MFCRenewForVestingMFSIsAlreadyExist",
    type: "error",
  },
  {
    inputs: [],
    name: "MFCRenewForVestingMFSIsOnlyOnActionTime",
    type: "error",
  },
  {
    inputs: [],
    name: "MFCRenewalAmountIs0",
    type: "error",
  },
  {
    inputs: [],
    name: "MFCRenewalPaymentIsOnlyPossibleInHMFS",
    type: "error",
  },
  {
    inputs: [],
    name: "MFCRewardsIsNotChange",
    type: "error",
  },
  {
    inputs: [],
    name: "MFCSizeArrayDifferentFromExpected",
    type: "error",
  },
  {
    inputs: [],
    name: "MFCSumRewardsMustBeHundred",
    type: "error",
  },
  {
    inputs: [],
    name: "MFCUserIsNotRegistredInMarketing",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "governor",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newGovernor",
        type: "address",
      },
    ],
    name: "GovernanceTransited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "accountId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "fromId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "marketing",
        type: "bool",
      },
    ],
    name: "LostMoney",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "MFCAmountChipEnergyForLevelIsSetted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "user",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestampEndPack",
        type: "uint256",
      },
    ],
    name: "MFCPackIsActivated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "user",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestampEndPack",
        type: "uint256",
      },
    ],
    name: "MFCPackIsRenewed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "registry",
        type: "address",
      },
    ],
    name: "MFCRegistryContractAddressSetted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "MFCRewardsChipEnergeForMarketingIsSetted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "user",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "MFCTokensMFSIsBuyingInOffer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "MFSPenaltyFactorForRenewalIsSetted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "governor",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newGovernor",
        type: "address",
      },
    ],
    name: "PendingGovernanceTransition",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "marketingRefererId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mRewardChipEnergy",
        type: "uint256",
      },
    ],
    name: "RevenueChipEnergy",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "accountId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "fromId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "activate",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "marketing",
        type: "bool",
      },
    ],
    name: "RevenueMFS",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "accountId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "fromId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "activate",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "marketing",
        type: "bool",
      },
    ],
    name: "RevenueStable",
    type: "event",
  },
  {
    inputs: [],
    name: "acceptGovernance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "forMFS",
        type: "bool",
      },
    ],
    name: "activationPack",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "amountChipEnergyForLevel",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "amountForSwapSFCR",
    outputs: [
      {
        internalType: "uint256",
        name: "amountForSwapSFCR",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "swapedSFCR",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "swapedSFCR2",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "senderId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "calcNeedDAIForRenew",
    outputs: [
      {
        internalType: "uint256[2]",
        name: "prices",
        type: "uint256[2]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "senderId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "calcNeedMFSForRenew",
    outputs: [
      {
        internalType: "uint256[2]",
        name: "prices",
        type: "uint256[2]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    name: "checkStatusRenewedPackForVestingMFS",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "countRenewal",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "datesForBuying",
    outputs: [
      {
        internalType: "uint256",
        name: "date",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "estimatedMarketinReferrerId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "forMFS",
        type: "bool",
      },
    ],
    name: "firstActivationPack",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "replaceId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "forMFS",
        type: "bool",
      },
    ],
    name: "firstActivationPackWithReplace",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "forMFS",
        type: "bool",
      },
    ],
    name: "giftPack",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "governor",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IRegistryContract",
        name: "_registry",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "lastIndexBuying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "penaltiyFactorForRenewal",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingGovernor",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "permissionSubsequentPurchase",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "amountsCurrency",
        type: "uint256[]",
      },
    ],
    name: "renewalPack",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "withoutConversionStable",
        type: "bool",
      },
    ],
    name: "renewalPackForMFS",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    name: "renewalPackForVestingMFS",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "renewedPackForVestingMFS",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rewardsChipEnergyForMarketing",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_amountChipEnergyForLevel",
        type: "uint256[]",
      },
    ],
    name: "setAmountChipEnergyForLevel",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_penalty",
        type: "uint256",
      },
    ],
    name: "setPenaltyForRenewal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_rewardsChipEnergyForMarketing",
        type: "uint256[]",
      },
    ],
    name: "setRewardsChipEnergyForMarketing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newGovernor",
        type: "address",
      },
      {
        internalType: "bool",
        name: "force",
        type: "bool",
      },
    ],
    name: "transitGovernance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "0x608060405234801561001057600080fd5b506001600255615bb880620000266000396000f3fe608060405234801561001057600080fd5b50600436106101b95760003560e01c8063a1f9a27a116100f9578063cf7b637d11610097578063ddc1252611610071578063ddc125261461044c578063e3056a341461045f578063e65c2fe014610472578063e90680da1461048557600080fd5b8063cf7b637d146103e6578063d1bd3106146103f9578063d993cab21461041e57600080fd5b8063bbe778b5116100d3578063bbe778b51461038a578063c059248c1461039d578063c4d66de8146103b0578063cd60e624146103c357600080fd5b8063a1f9a27a1461035b578063b1d4210414610364578063bb4c9fc01461037757600080fd5b80632a5155cd116101665780633a9ece8d116101405780633a9ece8d14610302578063517977cc1461031557806357f40ba91461032857806362549ef61461034857600080fd5b80632a5155cd1461026c57806333ff22ce146102a557806336baa629146102b857600080fd5b80630c340a24116101975780630c340a24146102205780631b7198bb14610251578063238efcbc1461026457600080fd5b806301e38ea5146101be57806302db9649146101eb57806304c8ddbd14610200575b600080fd5b6101d16101cc36600461562c565b610498565b604080519283526020830191909152015b60405180910390f35b6101fe6101f93660046156b9565b6104d4565b005b61021361020e366004615764565b610994565b6040516101e29190615790565b600054610239906201000090046001600160a01b031681565b6040516001600160a01b0390911681526020016101e2565b6101fe61025f3660046157d2565b610c1a565b6101fe610d93565b61029761027a36600461562c565b600360209081526000928352604080842090915290825290205481565b6040519081526020016101e2565b6102136102b3366004615764565b610e28565b6102e76102c636600461580b565b60066020526000908152604090208054600182015460029092015490919083565b604080519384526020840192909252908201526060016101e2565b6101fe610310366004615824565b611099565b6101fe6103233660046157d2565b6111d8565b61029761033636600461580b565b60056020526000908152604090205481565b6101fe6103563660046157d2565b6116b2565b61029760085481565b6101fe610372366004615824565b6118d8565b61029761038536600461580b565b6119d3565b6101fe6103983660046157d2565b6119f4565b6101fe6103ab36600461580b565b611d12565b6101fe6103be3660046158ae565b611f06565b6103d66103d136600461562c565b6120cf565b60405190151581526020016101e2565b6102976103f436600461580b565b6120f3565b6007546103d69074010000000000000000000000000000000000000000900460ff1681565b6103d661042c36600461562c565b600b60209081526000928352604080842090915290825290205460ff1681565b6101fe61045a3660046158cb565b612103565b600154610239906001600160a01b031681565b6101fe61048036600461580b565b612201565b6101fe6104933660046157d2565b612263565b600460205281600052604060002081815481106104b457600080fd5b600091825260209091206002909102018054600190910154909250905082565b60006104df336127e5565b90506104ec8484836128d4565b6007546040805163076a4fa560e11b815290516000926001600160a01b031691630ed49f4a9160048083019260209291908290030181865afa158015610536573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061055a9190615904565b9050600883511461057e57604051632697fba760e21b815260040160405180910390fd5b6003816001600160a01b0316632119351d6040518163ffffffff1660e01b8152600401602060405180830381865afa1580156105be573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906105e29190615937565b60038111156105f3576105f3615921565b146106115760405163604e23a560e11b815260040160405180910390fd5b60006106b5674563918244f400006106af61064761063861063360018c61596e565b612a3e565b671bc16d674ec8000090612a52565b856001600160a01b031663358dcec36040518163ffffffff1660e01b8152600401602060405180830381865afa158015610685573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906106a99190615981565b90612a94565b90612b68565b9050845b801561092257816106cc6001600861596e565b60008681526003602090815260408083208c845290915290205410156108925760008581526003602090815260408083208b84529091529020545b865181101561081457818782815181106107235761072361599a565b602002602001015110156107ab5761075f866107408360016159b0565b8984815181106107525761075261599a565b6020026020010151612b7d565b8681815181106107715761077161599a565b602002602001015182610784919061596e565b9150600087828151811061079a5761079a61599a565b60200260200101818152505061080c565b6107c0866107ba8360016159b0565b84612b7d565b818782815181106107d3576107d361599a565b60200260200101516107e5919061596e565b8782815181106107f7576107f761599a565b60200260200101818152505060009150610814565b600101610707565b50801561083457604051635de7d82160e11b815260040160405180910390fd5b6108418860018588612d9c565b60008581526003602090815260408083208b84529091529020546108669060016159b0565b60008681526003602090815260408083208c84529091529020558161088a816159c3565b92505061091c565b61089c82826159da565b866108a96001600861596e565b815181106108b9576108b961599a565b602002602001015110156108e057604051635de7d82160e11b815260040160405180910390fd5b610902856008886108f260018361596e565b815181106107525761075261599a565b61091788836109118a876159da565b88612d9c565b600091505b506106b9565b600086610967674563918244f40000600a61093e60018d61596e565b8154811061094e5761094e61599a565b9060005260206000200154612b6890919063ffffffff16565b61097191906159da565b905061098a85896109828a876159da565b846000612fb3565b5050505050505050565b61099c6155ae565b600080600760009054906101000a90046001600160a01b03166001600160a01b0316630ed49f4a6040518163ffffffff1660e01b8152600401602060405180830381865afa1580156109f2573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610a169190615904565b6040516330d61b2f60e01b815260048101889052602481018790529091506001600160a01b038216906330d61b2f90604401602060405180830381865afa158015610a65573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610a8991906159f1565b610aae5760405163212de5cf60e01b8152600481018690526024015b60405180910390fd5b600084610b0f674563918244f400006106af610ad161063861063360018d61596e565b866001600160a01b031663358dcec36040518163ffffffff1660e01b8152600401602060405180830381865afa158015610685573d6000803e3d6000fd5b610b1991906159da565b905060015b86811015610c0a576040516330d61b2f60e01b815260048101899052602481018290526001600160a01b038416906330d61b2f90604401602060405180830381865afa158015610b72573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b9691906159f1565b610c025785610bf56008546106a9610bb761063860018d610633919061596e565b876001600160a01b031663358dcec36040518163ffffffff1660e01b8152600401602060405180830381865afa158015610685573d6000803e3d6000fd5b610bff91906159da565b93505b600101610b1e565b5083525060208201529392505050565b6007546040805163076a4fa560e11b815290516000926001600160a01b031691630ed49f4a9160048083019260209291908290030181865afa158015610c64573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610c889190615904565b90506000610c95336127e5565b6040516312fc583760e11b8152600481018290529091506001600160a01b038316906325f8b06e90602401602060405180830381865afa158015610cdd573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d019190615981565b15610d1f5760405163e151d8e960e01b815260040160405180910390fd5b6040516372ade26760e11b815260048101869052602481018290526001600160a01b0383169063e55bc4ce90604401600060405180830381600087803b158015610d6857600080fd5b505af1158015610d7c573d6000803e3d6000fd5b50505050610d8c60018585612263565b5050505050565b6001546001600160a01b03163314610dbe5760405163aec80d4b60e01b815260040160405180910390fd5b60015460008054620100006001600160a01b0393841681810275ffffffffffffffffffffffffffffffffffffffff00001990931692909217808455604051929491900416917f564590b81987d147246f63910a8e1ee4eb09c4d64cc75ee975a8ffedfcc2210e91a3565b610e306155ae565b600080600760009054906101000a90046001600160a01b03166001600160a01b0316630ed49f4a6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610e86573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610eaa9190615904565b6040516330d61b2f60e01b815260048101889052602481018790529091506001600160a01b038216906330d61b2f90604401602060405180830381865afa158015610ef9573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f1d91906159f1565b610f3d5760405163212de5cf60e01b815260048101869052602401610aa5565b600084610f9e674563918244f400006106af610f6061063861063360018d61596e565b866001600160a01b0316636c079ec66040518163ffffffff1660e01b8152600401602060405180830381865afa158015610685573d6000803e3d6000fd5b610fa891906159da565b905060015b86811015610c0a576040516330d61b2f60e01b815260048101899052602481018290526001600160a01b038416906330d61b2f90604401602060405180830381865afa158015611001573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061102591906159f1565b61109157856110846008546106a961104661063860018d610633919061596e565b876001600160a01b0316636c079ec66040518163ffffffff1660e01b8152600401602060405180830381865afa158015610685573d6000803e3d6000fd5b61108e91906159da565b93505b600101610fad565b6000546201000090046001600160a01b031633146110ca576040516305e7700560e51b815260040160405180910390fd5b600082826040516020016110df929190615a0e565b6040516020818303038152906040528051906020012060096040516020016111079190615a50565b604051602081830303815290604052805190602001200361113b5760405163d09ae3a960e01b815260040160405180910390fd5b60005b82811015611174578383828181106111585761115861599a565b905060200201358261116a91906159b0565b915060010161113e565b5080670de0b6b3a76400001461119d57604051633ff658d360e01b815260040160405180910390fd5b6111a9600984846155cc565b506040517f2522e450e2b6ede235ae029b32ada8571c0a437a43f20c53d3035cc0d3265ed990600090a1505050565b60098211156111fa5760405163073e056f60e11b815260040160405180910390fd5b8160000361121b5760405163eb967cf960e01b815260040160405180910390fd5b6000611226336127e5565b90506000600760009054906101000a90046001600160a01b031690506000816001600160a01b0316630ed49f4a6040518163ffffffff1660e01b8152600401602060405180830381865afa158015611282573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906112a69190615904565b6040516330d61b2f60e01b815260048101889052602481018790529091506001600160a01b038216906330d61b2f90604401602060405180830381865afa1580156112f5573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061131991906159f1565b611643576040516312fc583760e11b8152600481018790526001600160a01b038216906325f8b06e90602401602060405180830381865afa158015611362573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906113869190615981565b6000036113a65760405163d9a3e0ef60e01b815260040160405180910390fd5b60015b85811015611449576040516330d61b2f60e01b815260048101889052602481018290526001600160a01b038316906330d61b2f90604401602060405180830381865afa1580156113fd573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061142191906159f1565b6114415760405163212de5cf60e01b815260048101829052602401610aa5565b6001016113a9565b50600061149e61146061063861063360018a61596e565b836001600160a01b0316636c079ec66040518163ffffffff1660e01b8152600401602060405180830381865afa158015610685573d6000803e3d6000fd5b9050841561151657604051632d5bdb4560e11b8152600481018290526001600160a01b03831690635ab7b68a90602401602060405180830381865afa1580156114eb573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061150f9190615981565b9050611523565b6115208482613158565b90505b61152d848261332e565b6001600160a01b03821663fedbb117888861154b62278d00426159b0565b6040516001600160e01b031960e086901b168152600481019390935260248301919091526044820152606401600060405180830381600087803b15801561159157600080fd5b505af11580156115a5573d6000803e3d6000fd5b505050506115e0878783600a60018b6115be919061596e565b815481106115ce576115ce61599a565b90600052602060002001546001612fb3565b6115ee87876001600061357f565b867f0e836704d347c01caa67d726287d6651854ffa770c503b6d059728c3c8f916f8878361161f62278d00426159b0565b6040805193845260208401929092529082015260600160405180910390a2506116aa565b61164b6155ae565b84156116645761165d87876001610994565b9050611698565b61167087876001610e28565b9050611684848260005b6020020151613158565b81526116928482600161167a565b60208201525b6116a881888689600160006138af565b505b505050505050565b6007546040805163076a4fa560e11b815290516000926001600160a01b031691630ed49f4a9160048083019260209291908290030181865afa1580156116fc573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906117209190615904565b9050600061172d336127e5565b6040516312fc583760e11b8152600481018290529091506001600160a01b038316906325f8b06e90602401602060405180830381865afa158015611775573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906117999190615981565b156117b75760405163e151d8e960e01b815260040160405180910390fd5b6040805160018082528183019092526000916020808301908036833701905050905085816000815181106117ed576117ed61599a565b602090810291909101015260405163021e3fa360e61b81526000906001600160a01b0385169063878fe8c090611827908590600401615ac8565b602060405180830381865afa158015611844573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906118689190615981565b6040516343facf1560e11b815260048101859052602481018290529091506001600160a01b038516906387f59e2a90604401600060405180830381600087803b1580156118b457600080fd5b505af11580156118c8573d6000803e3d6000fd5b505050506116a860018787612263565b6000546201000090046001600160a01b03163314611909576040516305e7700560e51b815260040160405180910390fd5b6009811461192a5760405163fdb263ff60e01b815260040160405180910390fd5b818160405160200161193d929190615a0e565b60405160208183030381529060405280519060200120600a6040516020016119659190615a50565b6040516020818303038152906040528051906020012003611999576040516327553d7160e21b815260040160405180910390fd5b6119a5600a83836155cc565b506040517ffaea85f241fa8b0d7991e8f4b1e7c910348ca76ffc93d148b57dd8182fb8b00190600090a15050565b600981815481106119e357600080fd5b600091825260209091200154905081565b60006119ff336127e5565b9050611a0c8484836128d4565b6007546040805163076a4fa560e11b815290516001600160a01b03909216916000918391630ed49f4a916004808201926020929091908290030181865afa158015611a5b573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611a7f9190615904565b905060006003826001600160a01b0316632119351d6040518163ffffffff1660e01b8152600401602060405180830381865afa158015611ac3573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611ae79190615937565b6003811115611af857611af8615921565b149050611b036155ae565b8515611b1b57611b14858989610994565b9050611b84565b611b26858989610e28565b90508115611b59578051600290611b48908790611b4390846159da565b613158565b611b529190615adb565b8152611b68565b611b658582600061167a565b81525b602081015115611b8457611b7e8582600161167a565b60208201525b8115611d03576000846001600160a01b031663c290f16a6040518163ffffffff1660e01b8152600401602060405180830381865afa158015611bca573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611bee9190615904565b90506000846001600160a01b031663b59019516040518163ffffffff1660e01b8152600401602060405180830381865afa158015611c30573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611c549190615981565b9050611c6362278d00826159b0565b421115611c8357604051630808644360e11b815260040160405180910390fd5b8251604051639f5ded3560e01b81526004810189905260006024820152604481018290526001600160a01b03841690639f5ded35906064016020604051808303816000875af1158015611cda573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611cfe9190615981565b505050505b61098a8186878b8b60006138af565b6000611d1d336127e5565b9050611d2b826001836128d4565b6007546040805163076a4fa560e11b815290516001600160a01b03909216916000918391630ed49f4a916004808201926020929091908290030181865afa158015611d7a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611d9e9190615904565b90506000816001600160a01b031663b59019516040518163ffffffff1660e01b8152600401602060405180830381865afa158015611de0573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611e049190615981565b90506003826001600160a01b0316632119351d6040518163ffffffff1660e01b8152600401602060405180830381865afa158015611e46573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611e6a9190615937565b6003811115611e7b57611e7b615921565b141580611e935750611e9062278d00826159b0565b42115b15611eb157604051632699fed560e01b815260040160405180910390fd5b6000848152600b6020908152604080832088845290915290205460ff1615611eec5760405163c338488d60e01b815260040160405180910390fd5b610d8c611efb85876001610994565b8586886001806138af565b6000611f307fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d61035490565b90506001600160a01b038116611f6f576001600160a01b037fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d610355611f84565b336001600160a01b03821614611f8457600080fd5b600054610100900460ff1615808015611fa45750600054600160ff909116105b80611fbe5750303b158015611fbe575060005460ff166001145b6120305760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201527f647920696e697469616c697a65640000000000000000000000000000000000006064820152608401610aa5565b6000805460ff191660011790558015612053576000805461ff0019166101001790555b61205c33613e71565b6007805473ffffffffffffffffffffffffffffffffffffffff19166001600160a01b03851617905580156120ca576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b505050565b6000828152600b6020908152604080832084845290915290205460ff165b92915050565b600a81815481106119e357600080fd5b6000546201000090046001600160a01b03163314612134576040516305e7700560e51b815260040160405180910390fd5b6001600160a01b03821661215b5760405163604b48b960e11b815260040160405180910390fd5b306001600160a01b03831603612184576040516306b3e95d60e21b815260040160405180910390fd5b6001805473ffffffffffffffffffffffffffffffffffffffff19166001600160a01b038416179055806121f457600080546040516001600160a01b03808616936201000090930416917fc606c9af1451cadeb333f6ff7b24a5540974f4e800bac274fa7fff9edc305cb191a35050565b6121fd82613e71565b5050565b6000546201000090046001600160a01b03163314612232576040516305e7700560e51b815260040160405180910390fd5b60088190556040517ff0d8afd1c541e4ec1d72748eec85173f92256b89443448500217776658fa76de90600090a150565b60098311156122855760405163073e056f60e11b815260040160405180910390fd5b826000036122a65760405163eb967cf960e01b815260040160405180910390fd5b816000036122c757604051636ffacb5960e01b815260040160405180910390fd5b6007546040805163076a4fa560e11b815290516001600160a01b03909216916000918391630ed49f4a916004808201926020929091908290030181865afa158015612316573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061233a9190615904565b90506000612347336127e5565b6040516330d61b2f60e01b815260048101829052602481018890529091506000906001600160a01b038416906330d61b2f90604401602060405180830381865afa158015612399573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906123bd91906159f1565b15612439576040516305b2f09560e31b815260048101839052602481018890526001600160a01b03841690632d9784a890604401602060405180830381865afa15801561240e573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906124329190615981565b905061243c565b50425b6040516312fc583760e11b8152600481018390526001600160a01b038416906325f8b06e90602401602060405180830381865afa158015612481573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906124a59190615981565b6000036124c55760405163d9a3e0ef60e01b815260040160405180910390fd5b6001836001600160a01b0316632119351d6040518163ffffffff1660e01b8152600401602060405180830381865afa158015612505573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906125299190615937565b600381111561253a5761253a615921565b101561255957604051637e9ee27160e11b815260040160405180910390fd5b60015b878110156125fc576040516330d61b2f60e01b815260048101849052602481018290526001600160a01b038516906330d61b2f90604401602060405180830381865afa1580156125b0573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906125d491906159f1565b6125f45760405163212de5cf60e01b815260048101829052602401610aa5565b60010161255c565b50600086612614610f6061063861063360018d61596e565b61261e91906159da565b9050851561269657604051632d5bdb4560e11b8152600481018290526001600160a01b03851690635ab7b68a90602401602060405180830381865afa15801561266b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061268f9190615981565b90506126a3565b6126a08382613158565b90505b6126ad838261332e565b6001600160a01b03841663fedbb117848a6126cb8b62278d006159da565b6126d590876159b0565b6040516001600160e01b031960e086901b168152600481019390935260248301919091526044820152606401600060405180830381600087803b15801561271b57600080fd5b505af115801561272f573d6000803e3d6000fd5b505050506127758389838a600a60018e612749919061596e565b815481106127595761275961599a565b906000526020600020015461276e91906159da565b6001612fb3565b612782838989600061357f565b827f0e836704d347c01caa67d726287d6651854ffa770c503b6d059728c3c8f916f889836127b38b62278d006159da565b6127bd90876159b0565b6040805193845260208401929092529082015260600160405180910390a25050505050505050565b600080600760009054906101000a90046001600160a01b03166001600160a01b0316630fa7bbdd6040518163ffffffff1660e01b8152600401602060405180830381865afa15801561283b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061285f9190615904565b60405163e2a4128360e01b81526001600160a01b0385811660048301529192509082169063e2a4128390602401602060405180830381865afa1580156128a9573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906128cd9190615981565b9392505050565b6007546040805163076a4fa560e11b815290516000926001600160a01b031691630ed49f4a9160048083019260209291908290030181865afa15801561291e573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906129429190615904565b905060098411156129665760405163073e056f60e11b815260040160405180910390fd5b836000036129875760405163eb967cf960e01b815260040160405180910390fd5b826000036129a857604051636647f6d160e11b815260040160405180910390fd5b6040516330d61b2f60e01b815260048101839052602481018590526001600160a01b038216906330d61b2f90604401602060405180830381865afa1580156129f4573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612a1891906159f1565b612a385760405163212de5cf60e01b815260048101859052602401610aa5565b50505050565b60006120ed670de0b6b3a7640000836159da565b600082600003612a7a578115612a69576000612a73565b670de0b6b3a76400005b90506120ed565b6128cd612a8f612a8985613ed8565b84612a94565b613f8e565b60008080600019848609848602925082811083820303915050670de0b6b3a76400008110612ae65760405163072fa3c960e31b815260048101829052670de0b6b3a76400006024820152604401610aa5565b600080670de0b6b3a764000086880991506706f05b59d3b1ffff8211905082600003612b245780670de0b6b3a76400008504019450505050506120ed565b620400008285030493909111909103600160ee1b02919091177faccb18165bd6fe31ae1cf318dc5b51eee0e1ba569b88cd74c1773b91fac106690201905092915050565b60006128cd83670de0b6b3a7640000846146dd565b60075460408051630fa7bbdd60e01b815290516001600160a01b03909216916000918391630fa7bbdd916004808201926020929091908290030181865afa158015612bcc573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612bf09190615904565b6001600160a01b03166359b77b1e6040518163ffffffff1660e01b8152600401602060405180830381865afa158015612c2d573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612c519190615904565b604051634b3cf3a160e11b8152600481018690529091506000906001600160a01b03841690639679e74290602401602060405180830381865afa158015612c9c573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612cc09190615904565b60405163a84308a160e01b81526001600160a01b03808316600483015260248201899052306044830152606482018790529192509083169063a84308a190608401600060405180830381600087803b158015612d1b57600080fd5b505af1158015612d2f573d6000803e3d6000fd5b5050604051632770a7eb60e21b8152306004820152602481018790526001600160a01b0384169250639dc29fac91506044015b600060405180830381600087803b158015612d7c57600080fd5b505af1158015612d90573d6000803e3d6000fd5b50505050505050505050565b6002805403612ded5760405162461bcd60e51b815260206004820152601f60248201527f5265656e7472616e637947756172643a207265656e7472616e742063616c6c006044820152606401610aa5565b600280556007546040805163076a4fa560e11b815290516000926001600160a01b031691630ed49f4a9160048083019260209291908290030181865afa158015612e3b573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612e5f9190615904565b90506001600160a01b03811663230577748387612e7f8862278d006159da565b6040516001600160e01b031960e086901b168152600481019390935260248301919091526044820152606401600060405180830381600087803b158015612ec557600080fd5b505af1158015612ed9573d6000803e3d6000fd5b50505050612ef18286866702c68af0bb14000061357f565b6040516305b2f09560e31b8152600481018390526024810186905282907f2b77ce596797c0c2f4f6cc0f6b1a1f977e6d95a43f2011dc0f5a4ae76ffc8cc590879086906001600160a01b03861690632d9784a890604401602060405180830381865afa158015612f65573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612f899190615981565b6040805193845260208401929092529082015260600160405180910390a250506001600255505050565b6007546040805163076a4fa560e11b815290516001600160a01b03909216916000918391630ed49f4a916004808201926020929091908290030181865afa158015613002573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906130269190615904565b90506000613035600287615adb565b9050816001600160a01b031663742a8c77846001600160a01b0316635b4bfef16040518163ffffffff1660e01b8152600401602060405180830381865afa158015613084573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906130a89190615904565b6040516001600160e01b031960e084901b1681526001600160a01b03909116600482015260248101849052604401600060405180830381600087803b1580156130f057600080fd5b505af1158015613104573d6000803e3d6000fd5b5050505061311d888288613118919061596e565b61479b565b6000613134898961312e858b61596e565b886149b6565b905061314d8989613145858b61596e565b848a8a614d1d565b505050505050505050565b6007546040805163373e0e2360e11b815290516000926001600160a01b03169183918391636e7c1c469160048083019260209291908290030181865afa1580156131a6573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906131ca9190615904565b90506000826001600160a01b03166332479a5e6040518163ffffffff1660e01b8152600401602060405180830381865afa15801561320c573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906132309190615904565b90506000836001600160a01b0316631bd817c96040518163ffffffff1660e01b8152600401602060405180830381865afa158015613272573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906132969190615904565b604051634b00284760e01b8152600481018990526001600160a01b0380831660248301528481166044830152606482018990526000608483015291925090841690634b0028479060a4016020604051808303816000875af11580156132ff573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906133239190615981565b979650505050505050565b60075460408051631923cd2f60e11b815290516001600160a01b039092169160009183916332479a5e916004808201926020929091908290030181865afa15801561337d573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906133a19190615904565b90506000826001600160a01b0316630fa7bbdd6040518163ffffffff1660e01b8152600401602060405180830381865afa1580156133e3573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906134079190615904565b6001600160a01b03166359b77b1e6040518163ffffffff1660e01b8152600401602060405180830381865afa158015613444573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906134689190615904565b90506000836001600160a01b03166368bbc4896040518163ffffffff1660e01b8152600401602060405180830381865afa1580156134aa573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906134ce9190615904565b60405163bf7fc61b60e01b81526001600160a01b03858116600483015260248201899052604482018890529192509083169063bf7fc61b90606401600060405180830381600087803b15801561352357600080fd5b505af1158015613537573d6000803e3d6000fd5b505060405163a84308a160e01b81526001600160a01b038681166004830152602482018a90528481166044830152606482018990528516925063a84308a19150608401612d62565b60075460408051630fa7bbdd60e01b815290516001600160a01b03909216916000918391630fa7bbdd916004808201926020929091908290030181865afa1580156135ce573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906135f29190615904565b60405163486cbb7160e11b8152600481018890529091506000906001600160a01b038316906390d976e290602401602060405180830381865afa15801561363d573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906136619190615904565b6040516301764db560e31b8152600481018890529091506000906001600160a01b03851690630bb26da890602401602060405180830381865afa1580156136ac573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906136d09190615904565b9050606060005b878110156137cb57826001600160a01b03166375794a3c6040518163ffffffff1660e01b8152600401602060405180830381865afa15801561371d573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906137419190615981565b8282815181106137535761375361599a565b60209081029190910101526040516340c10f1960e01b81526001600160a01b038581166004830152602482018990528416906340c10f1990604401600060405180830381600087803b1580156137a857600080fd5b505af11580156137bc573d6000803e3d6000fd5b505050508060010190506136d7565b50600760009054906101000a90046001600160a01b03166001600160a01b031663a835eaa66040518163ffffffff1660e01b8152600401602060405180830381865afa15801561381f573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906138439190615904565b6001600160a01b031663ca7c6ffd898b846040518463ffffffff1660e01b815260040161387293929190615afd565b600060405180830381600087803b15801561388c57600080fd5b505af11580156138a0573d6000803e3d6000fd5b50505050505050505050505050565b60075460408051630fa7bbdd60e01b815290516001600160a01b03909216916000918391630fa7bbdd916004808201926020929091908290030181865afa1580156138fe573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906139229190615904565b6001600160a01b03166359b77b1e6040518163ffffffff1660e01b8152600401602060405180830381865afa15801561395f573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906139839190615904565b90508215613b8e57806001600160a01b031663bf7fc61b836001600160a01b03166332479a5e6040518163ffffffff1660e01b8152600401602060405180830381865afa1580156139d8573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906139fc9190615904565b888b600160200201518c60006020020151866001600160a01b0316632b04e840896001600160a01b03166332479a5e6040518163ffffffff1660e01b8152600401602060405180830381865afa158015613a5a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190613a7e9190615904565b6040516001600160e01b031960e084901b1681526001600160a01b039091166004820152602481018f90526044016020604051808303816000875af1158015613acb573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190613aef9190615981565b613af991906159b0565b613b0391906159b0565b6040516001600160e01b031960e086901b1681526001600160a01b03909316600484015260248301919091526044820152606401600060405180830381600087803b158015613b5157600080fd5b505af1158015613b65573d6000803e3d6000fd5b5050506000878152600b602090815260408083208984529091529020805460ff19166001179055505b602088015115613cdc576000826001600160a01b03166332479a5e6040518163ffffffff1660e01b8152600401602060405180830381865afa158015613bd8573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190613bfc9190615904565b60208a015160405163a84308a160e01b81526001600160a01b038084166004830152602482018b9052306044830152606482019290925291925083169063a84308a190608401600060405180830381600087803b158015613c5c57600080fd5b505af1158015613c70573d6000803e3d6000fd5b50505060208a0151604051632770a7eb60e21b815230600482015260248101919091526001600160a01b0383169150639dc29fac90604401600060405180830381600087803b158015613cc257600080fd5b505af1158015613cd6573d6000803e3d6000fd5b50505050505b806001600160a01b031663a84308a1836001600160a01b03166332479a5e6040518163ffffffff1660e01b8152600401602060405180830381865afa158015613d29573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190613d4d9190615904565b88856001600160a01b03166368bbc4896040518163ffffffff1660e01b8152600401602060405180830381865afa158015613d8c573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190613db09190615904565b8c5160405160e086901b6001600160e01b03191681526001600160a01b0394851660048201526024810193909352921660448201526064810191909152608401600060405180830381600087803b158015613e0a57600080fd5b505af1158015613e1e573d6000803e3d6000fd5b50505050600084613e40674563918244f40000600a60018a61093e919061596e565b613e4a91906159da565b9050613e6188878b60006020020151846000612fb3565b885161314d90879087908b612d9c565b6000805475ffffffffffffffffffffffffffffffffffffffff00001916620100006001600160a01b0384811682810293909317808555604051939492900416917f564590b81987d147246f63910a8e1ee4eb09c4d64cc75ee975a8ffedfcc2210e9190a350565b6000670de0b6b3a7640000821015613f065760405163c427d0c960e01b815260048101839052602401610aa5565b6000613f1b670de0b6b3a764000084046152dc565b670de0b6b3a764000081029250905082811c670de0b6b3a763ffff198101613f44575050919050565b6706f05b59d3b200005b8015613f8657670de0b6b3a7640000828002049150671bc16d674ec800008210613f7e579283019260019190911c905b60011c613f4e565b505050919050565b6000680a688906bd8b0000008210613fbc57604051632132de2160e01b815260048101839052602401610aa5565b50670de0b6b3a764000060409190911b04778000000000000000000000000000000000000000000000006780000000000000008216156140055768016a09e667f3bcc9090260401c5b674000000000000000821615614024576801306fe0a31b7152df0260401c5b672000000000000000821615614043576801172b83c7d517adce0260401c5b6710000000000000008216156140625768010b5586cf9890f62a0260401c5b670800000000000000821615614081576801059b0d31585743ae0260401c5b6704000000000000008216156140a057680102c9a3e778060ee70260401c5b6702000000000000008216156140bf5768010163da9fb33356d80260401c5b6701000000000000008216156140de57680100b1afa5abcbed610260401c5b66800000000000008216156140fc5768010058c86da1c09ea20260401c5b664000000000000082161561411a576801002c605e2e8cec500260401c5b662000000000000082161561413857680100162f3904051fa10260401c5b6610000000000000821615614156576801000b175effdc76ba0260401c5b660800000000000082161561417457680100058ba01fb9f96d0260401c5b66040000000000008216156141925768010002c5cc37da94920260401c5b66020000000000008216156141b0576801000162e525ee05470260401c5b66010000000000008216156141ce5768010000b17255775c040260401c5b658000000000008216156141eb576801000058b91b5bc9ae0260401c5b6540000000000082161561420857680100002c5c89d5ec6d0260401c5b652000000000008216156142255768010000162e43f4f8310260401c5b6510000000000082161561424257680100000b1721bcfc9a0260401c5b6508000000000082161561425f5768010000058b90cf1e6e0260401c5b6504000000000082161561427c576801000002c5c863b73f0260401c5b6502000000000082161561429957680100000162e430e5a20260401c5b650100000000008216156142b6576801000000b1721835510260401c5b6480000000008216156142d257680100000058b90c0b490260401c5b6440000000008216156142ee5768010000002c5c8601cc0260401c5b64200000000082161561430a576801000000162e42fff00260401c5b6410000000008216156143265768010000000b17217fbb0260401c5b640800000000821615614342576801000000058b90bfce0260401c5b64040000000082161561435e57680100000002c5c85fe30260401c5b64020000000082161561437a5768010000000162e42ff10260401c5b64010000000082161561439657680100000000b17217f80260401c5b63800000008216156143b15768010000000058b90bfc0260401c5b63400000008216156143cc576801000000002c5c85fe0260401c5b63200000008216156143e757680100000000162e42ff0260401c5b6310000000821615614402576801000000000b17217f0260401c5b630800000082161561441d57680100000000058b90c00260401c5b63040000008216156144385768010000000002c5c8600260401c5b6302000000821615614453576801000000000162e4300260401c5b630100000082161561446e5768010000000000b172180260401c5b62800000821615614488576801000000000058b90c0260401c5b624000008216156144a257680100000000002c5c860260401c5b622000008216156144bc5768010000000000162e430260401c5b621000008216156144d657680100000000000b17210260401c5b620800008216156144f05768010000000000058b910260401c5b6204000082161561450a576801000000000002c5c80260401c5b6202000082161561452457680100000000000162e40260401c5b6201000082161561453e576801000000000000b1720260401c5b61800082161561455757680100000000000058b90260401c5b6140008216156145705768010000000000002c5d0260401c5b612000821615614589576801000000000000162e0260401c5b6110008216156145a25768010000000000000b170260401c5b6108008216156145bb576801000000000000058c0260401c5b6104008216156145d457680100000000000002c60260401c5b6102008216156145ed57680100000000000001630260401c5b61010082161561460657680100000000000000b10260401c5b608082161561461e57680100000000000000590260401c5b6040821615614636576801000000000000002c0260401c5b602082161561464e57680100000000000000160260401c5b6010821615614666576801000000000000000b0260401c5b600882161561467e57680100000000000000060260401c5b600482161561469657680100000000000000030260401c5b60028216156146ae57680100000000000000010260401c5b60018216156146c657680100000000000000010260401c5b670de0b6b3a76400000260409190911c60bf031c90565b600080806000198587098587029250828110838203039150508381106147205760405163072fa3c960e31b81526004810182905260248101859052604401610aa5565b80600003614733575082900490506128cd565b600084868809600260036001881981018916988990049182028318808302840302808302840302808302840302808302840302808302840302918202909203026000889003889004909101858311909403939093029303949094049190911702949350505050565b60075460408051630fa7bbdd60e01b815290516001600160a01b03909216916000918391630fa7bbdd916004808201926020929091908290030181865afa1580156147ea573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061480e9190615904565b6001600160a01b03166359b77b1e6040518163ffffffff1660e01b8152600401602060405180830381865afa15801561484b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061486f9190615904565b90506000826001600160a01b031663ec360aba6040518163ffffffff1660e01b8152600401602060405180830381865afa1580156148b1573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906148d59190615904565b6040516340c10f1960e01b81526001600160a01b03848116600483015260248201879052919250908216906340c10f1990604401600060405180830381600087803b15801561492357600080fd5b505af1158015614937573d6000803e3d6000fd5b5050604051631e9f7a9b60e01b81526001600160a01b038481166004830152602482018990526044820188905285169250631e9f7a9b91506064015b6020604051808303816000875af1158015614992573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906116aa9190615981565b6007546040805163076a4fa560e11b815290516000926001600160a01b03169183918391630ed49f4a9160048083019260209291908290030181865afa158015614a04573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190614a289190615904565b90508492506000816001600160a01b0316633905301e6040518163ffffffff1660e01b8152600401600060405180830381865afa158015614a6d573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052614a959190810190615b25565b90508760005b8251811015614d10576000614ad2848381518110614abb57614abb61599a565b60200260200101518a612a9490919063ffffffff16565b90505b604051630c63101d60e11b8152600481018490526001600160a01b038616906318c6203a90602401602060405180830381865afa158015614b1a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190614b3e9190615981565b6040516330d61b2f60e01b815260048101829052602481018c90529093506001600160a01b038616906330d61b2f90604401602060405180830381865afa158015614b8d573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190614bb191906159f1565b614bf75760408051828152600060208201528c9185917f5a96190930b91e8dd4955a84afe326060586e4dd8e1224ca998d354b1ed3700a910160405180910390a3614ad5565b614c01818861596e565b604051636e56fa5160e11b815260048101859052602481018390529097506001600160a01b0386169063dcadf4a290604401600060405180830381600087803b158015614c4d57600080fd5b505af1158015614c61573d6000803e3d6000fd5b505050508715614cbb5760408051828152602081018c90526001818301526000606082015290518c9185917f03ff06e6a472355a8312c81dec8a63e8ea6131749d7423ad89b6bf5a9b98855c9181900360800190a3614d07565b60408051828152602081018c90526000818301819052606082015290518c9185917f03ff06e6a472355a8312c81dec8a63e8ea6131749d7423ad89b6bf5a9b98855c9181900360800190a35b50600101614a9b565b5050505050949350505050565b6007546040805163076a4fa560e11b815290516001600160a01b03909216916000918391630ed49f4a916004808201926020929091908290030181865afa158015614d6c573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190614d909190615904565b90506000816001600160a01b0316638d0405826040518163ffffffff1660e01b8152600401600060405180830381865afa158015614dd2573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052614dfa9190810190615b25565b60095490915089908660005b845181101561514a576000614e3d868381518110614e2657614e2661599a565b60200260200101518d612a9490919063ffffffff16565b90505b6040516312fc583760e11b8152600481018690526001600160a01b038816906325f8b06e90602401602060405180830381865afa158015614e85573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190614ea99190615981565b6040516330d61b2f60e01b815260048101829052602481018f90529095506001600160a01b038816906330d61b2f90604401602060405180830381865afa158015614ef8573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190614f1c91906159f1565b614f625760408051828152600160208201528f9187917f5a96190930b91e8dd4955a84afe326060586e4dd8e1224ca998d354b1ed3700a910160405180910390a3614e40565b60018651614f70919061596e565b821015614f8857614f81818c61596e565b9a50614f8b565b50895b604051636e56fa5160e11b815260048101869052602481018290526001600160a01b0388169063dcadf4a290604401600060405180830381600087803b158015614fd457600080fd5b505af1158015614fe8573d6000803e3d6000fd5b50505050838210156150955760006150266009848154811061500c5761500c61599a565b90600052602060002001548c612a9490919063ffffffff16565b905061503360018661596e565b83101561504b57615044818561596e565b935061504e565b50825b61505886826153d2565b8e867fdb62a70303b15a6dacdb78bf052e7e9cc4c1557493888654d6edc3b8d692db078360405161508b91815260200190565b60405180910390a3505b8c89156150f0576040805183815260208101839052600191810182905260608101919091528f9087907f03ff06e6a472355a8312c81dec8a63e8ea6131749d7423ad89b6bf5a9b98855c9060800160405180910390a3615140565b6040805183815260208101839052600091810191909152600160608201528f9087907f03ff06e6a472355a8312c81dec8a63e8ea6131749d7423ad89b6bf5a9b98855c9060800160405180910390a35b5050600101614e06565b828110156138a0575b6040516312fc583760e11b8152600481018590526001600160a01b038716906325f8b06e90602401602060405180830381865afa158015615198573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906151bc9190615981565b6040516330d61b2f60e01b815260048101829052602481018e90529094506001600160a01b038716906330d61b2f90604401602060405180830381865afa15801561520b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061522f91906159f1565b156151535760006152666009838154811061524c5761524c61599a565b90600052602060002001548b612a9490919063ffffffff16565b905061527360018561596e565b82101561528b57615284818461596e565b925061528e565b50815b61529885826153d2565b8d857fdb62a70303b15a6dacdb78bf052e7e9cc4c1557493888654d6edc3b8d692db07836040516152cb91815260200190565b60405180910390a35060010161514a565b6000700100000000000000000000000000000000821061530957608091821c9161530690826159b0565b90505b68010000000000000000821061532c57604091821c9161532990826159b0565b90505b640100000000821061534b57602091821c9161534890826159b0565b90505b62010000821061536857601091821c9161536590826159b0565b90505b610100821061538457600891821c9161538190826159b0565b90505b6010821061539f57600491821c9161539c90826159b0565b90505b600482106153ba57600291821c916153b790826159b0565b90505b600282106153cd576120ed6001826159b0565b919050565b6007546040805163cdc935d560e01b815290516001600160a01b0390921691600091839163cdc935d5916004808201926020929091908290030181865afa158015615421573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906154459190615904565b90506000826001600160a01b0316630fa7bbdd6040518163ffffffff1660e01b8152600401602060405180830381865afa158015615487573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906154ab9190615904565b6001600160a01b03166359b77b1e6040518163ffffffff1660e01b8152600401602060405180830381865afa1580156154e8573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061550c9190615904565b6040516340c10f1960e01b81526001600160a01b03808316600483015260248201879052919250908316906340c10f1990604401600060405180830381600087803b15801561555a57600080fd5b505af115801561556e573d6000803e3d6000fd5b5050604051631e9f7a9b60e01b81526001600160a01b038581166004830152602482018990526044820188905284169250631e9f7a9b9150606401614973565b60405180604001604052806002906020820280368337509192915050565b828054828255906000526020600020908101928215615607579160200282015b828111156156075782358255916020019190600101906155ec565b50615613929150615617565b5090565b5b808211156156135760008155600101615618565b6000806040838503121561563f57600080fd5b50508035926020909101359150565b634e487b7160e01b600052604160045260246000fd5b604051601f8201601f1916810167ffffffffffffffff8111828210171561568d5761568d61564e565b604052919050565b600067ffffffffffffffff8211156156af576156af61564e565b5060051b60200190565b6000806000606084860312156156ce57600080fd5b833592506020808501359250604085013567ffffffffffffffff8111156156f457600080fd5b8501601f8101871361570557600080fd5b803561571861571382615695565b615664565b81815260059190911b8201830190838101908983111561573757600080fd5b928401925b828410156157555783358252928401929084019061573c565b80955050505050509250925092565b60008060006060848603121561577957600080fd5b505081359360208301359350604090920135919050565b60408101818360005b60028110156157b8578151835260209283019290910190600101615799565b50505092915050565b80151581146157cf57600080fd5b50565b6000806000606084860312156157e757600080fd5b83359250602084013591506040840135615800816157c1565b809150509250925092565b60006020828403121561581d57600080fd5b5035919050565b6000806020838503121561583757600080fd5b823567ffffffffffffffff8082111561584f57600080fd5b818501915085601f83011261586357600080fd5b81358181111561587257600080fd5b8660208260051b850101111561588757600080fd5b60209290920196919550909350505050565b6001600160a01b03811681146157cf57600080fd5b6000602082840312156158c057600080fd5b81356128cd81615899565b600080604083850312156158de57600080fd5b82356158e981615899565b915060208301356158f9816157c1565b809150509250929050565b60006020828403121561591657600080fd5b81516128cd81615899565b634e487b7160e01b600052602160045260246000fd5b60006020828403121561594957600080fd5b8151600481106128cd57600080fd5b634e487b7160e01b600052601160045260246000fd5b818103818111156120ed576120ed615958565b60006020828403121561599357600080fd5b5051919050565b634e487b7160e01b600052603260045260246000fd5b808201808211156120ed576120ed615958565b6000816159d2576159d2615958565b506000190190565b80820281158282048414176120ed576120ed615958565b600060208284031215615a0357600080fd5b81516128cd816157c1565b60007f07ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff831115615a3d57600080fd5b8260051b80858437919091019392505050565b60008183548391508460005260208060002060005b83811015615a8157815485529382019360019182019101615a65565b50929695505050505050565b600081518084526020808501945080840160005b83811015615abd57815187529582019590820190600101615aa1565b509495945050505050565b6020815260006128cd6020830184615a8d565b600082615af857634e487b7160e01b600052601260045260246000fd5b500490565b838152826020820152606060408201526000615b1c6060830184615a8d565b95945050505050565b60006020808385031215615b3857600080fd5b825167ffffffffffffffff811115615b4f57600080fd5b8301601f81018513615b6057600080fd5b8051615b6e61571382615695565b81815260059190911b82018301908381019087831115615b8d57600080fd5b928401925b8284101561332357835182529284019290840190615b9256fea164736f6c6343000811000a";

type MetaForceConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MetaForceConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MetaForce__factory extends ContractFactory {
  constructor(...args: MetaForceConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<MetaForce> {
    return super.deploy(overrides || {}) as Promise<MetaForce>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): MetaForce {
    return super.attach(address) as MetaForce;
  }
  override connect(signer: Signer): MetaForce__factory {
    return super.connect(signer) as MetaForce__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MetaForceInterface {
    return new utils.Interface(_abi) as MetaForceInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MetaForce {
    return new Contract(address, _abi, signerOrProvider) as MetaForce;
  }
}
